var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('td-device',{ref:"listAdapter",attrs:{"buttons":_vm.buttons,"inputs":_vm.inputs,"addTitle":_vm.title,"defaultPort":_vm.defaultPort,"columns":_vm.columns,"devDisplay":_vm.devDisplay,"deviceLable":_vm.deviceLable,"isOverWriteAdd":false,"iDeviceTypes":_vm.iDeviceTypes},on:{"event":_vm.changeNode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }